/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-12 10:22:49
 * @LastEditTime: 2019-08-13 11:22:17
 * @LastEditors: Please set LastEditors
 */
import Vue from 'vue'
import Router from 'vue-router'
import home from '@/views/home/home'
const prizeDetail = () => import('@/views/prizeDetail/prizeDetail')
const index = () => import('@/views/index/index')
const LuckyNumber = () => import('@/views/LuckyNumber/LuckyNumber')
const HistoryNumber = () => import('@/views/HistoryNumber/HistoryNumber')
const addressManage = () => import('@/views/addressManage/addressManage')
const addressEdit = () => import('@/views/addressManage/addressEdit')
const helpCenter = () => import('@/views/helpCenter/helpCenter')
const userInfo = () => import('@/views/userInfo/userInfo')
const buyDetail = () => import('@/views/buyDetail/buyDetail')
const receiveDetail = () => import('@/views/buyDetail/receiveDetail')
const getVirtualPrize = () => import('@/views/buyDetail/getVirtualPrize')
const addressSelect = () => import('@/views/buyDetail/addressSelect')
const luckyMoneyDetail = () => import('@/views/luckyMoneyDetail/luckyMoneyDetail')
const luckyNumDetail = () => import('@/views/luckyNumDetail/luckyNumDetail')
const loginOrReg = () => import('@/views/loginOrReg/loginOrReg')
const modifyUserName = () => import('@/views/modifyUserName/modifyUserName')
const bindPhone = () => import('@/views/bindPhone/bindPhone')
const pGetBack = () => import('@/views/password/pGetBack/pGetBack')
const pModify = () => import('@/views/password/pModify/pModify')
const pay = () => import('@/views/pay/pay')
const luckyPay = () => import('@/views/luckyPay/luckyPay')
const payHelp = () => import('@/views/pay/payHelp/payHelp')
const latesNews = () => import('@/views/latesNews/latesNews')
const giftMoreDetail = () => import('@/views/giftMoreDetail/giftMoreDetail')
const regProtocol = () => import('@/views/loginOrReg/regProtocol/regProtocol')
const caculateDetail = () => import('@/views/caculateDetail/caculateDetail')
const LuckyNumPay = () => import('@/views/LuckyNumPay/LuckyNumPay')
const newHome = () => import('@/views/newHome/newHome')
const analysis = () => import('@/views/analysis/analysis')
const historyAnalysis = () => import('@/views/historyAnalysis/historyAnalysis')
const historyAnalysis1 = () => import('@/views/historyAnalysis/historyAnalysis1')
const historyAnalysisDetail = () => import('@/views/historyAnalysis/historyAnalysisDetail')
const excellentPlan = () => import('@/views/historyAnalysis/excellentPlan')
Vue.use(Router)

export default new Router({
    mode: 'history',
    scrollBehavior (to, from, savedPosition) {
            return { x: 0, y: 0 }
    },
    routes: [
        {
            path: '/',
            redirect: {
                name: 'newHome'
            }
        },
        {
            path: '/LuckyHome',
            name: 'newHome',
            component: newHome,
            meta: {
                title: '幸运选号',
                backIsshow: false,
                shareIsshow: true,
                keepAlive: true,
                isMarginTop: false,
                isRefreshShow: false
            }
        },
        {
            path: '/home/:homeType?',
            name: 'Home',
            component: home,
            meta: {
                title: '抢多多',
                backIsshow: false,
                shareIsshow: true,
                keepAlive: true,
                isMarginTop: false,
                isRefreshShow: true
            }
        },
        {
            path: '/prizeDetail/:searchType/:prizeId',
            name: 'PrizeDetail',
            component: prizeDetail,
            meta: {
                title: '奖品详情',
                backIsshow: false,
                shareIsshow: true,
                keepAlive: false,
                isMarginTop: false,
                isRefreshShow: true
            }
        },
        {
            path: '/index',
            name: 'index',
            component: index,
            meta: {
                title: '个人中心',
                backIsshow: true,
                shareIsshow: false,
                keepAlive: true,
                isMarginTop: true,
                isRefreshShow: true
            }
        },
        {
            path: '/addressManage',
            name: 'addressManage',
            component: addressManage,
            meta: {
                title: '地址管理',
                backIsshow: true,
                shareIsshow: false,
                keepAlive: true,
                isMarginTop: true,
                isRefreshShow: false
            }
        },
        {
            path: '/addressEdit/:itemExchSta/:itemExchNum/:winId/:id',
            name: 'addressEdit',
            component: addressEdit,
            meta: {
                title: '填写地址',
                backIsshow: true,
                shareIsshow: false,
                keepAlive: false,
                isMarginTop: true,
                isRefreshShow: false
            }
        },
        {
            path: '/LuckyNumber/:orderId?',
            name: 'LuckyNumber',
            component: LuckyNumber,
            meta: {
                title: '幸运号码',
                backIsshow: false,
                shareIsshow: false,
                keepAlive: false,
                isMarginTop: false,
                isRefreshShow: false
            }
        },
        {
            path: '/HistoryNumber',
            name: 'HistoryNumber',
            component: HistoryNumber,
            meta: {
                title: '历史幸运号码',
                backIsshow: false,
                shareIsshow: false,
                keepAlive: false,
                isMarginTop: false,
                isRefreshShow: false
            }
        },
        {
            path: '/LuckyNumPay/:orderId?',
            name: 'LuckyNumPay',
            component: LuckyNumPay,
            meta: {
                title: '幸运号码',
                backIsshow: false,
                shareIsshow: false,
                keepAlive: false,
                isMarginTop: false,
                isRefreshShow: false
            }
        },
        {
            path: '/helpCenter',
            name: 'helpCenter',
            component: helpCenter,
            meta: {
                title: '帮助中心',
                backIsshow: true,
                shareIsshow: false,
                keepAlive: false,
                isMarginTop: true,
                isRefreshShow: true
            }
        },
        {
            path: '/userInfo',
            name: 'userInfo',
            component: userInfo,
            meta: {
                title: '个人信息',
                backIsshow: true,
                shareIsshow: false,
                keepAlive: false,
                isMarginTop: true,
                isRefreshShow: false
            }
        },
        {
            path: '/buyDetail/:id',
            name: 'buyDetail',
            component: buyDetail,
            meta: {
                title: '参与记录',
                backIsshow: true,
                shareIsshow: false,
                keepAlive: true,
                isMarginTop: true,
                isRefreshShow: true
            }
        },
        {
            path: '/receiveDetail/:winId',
            name: 'receiveDetail',
            component: receiveDetail,
            meta: {
                title: '领取详情',
                backIsshow: true,
                shareIsshow: false,
                keepAlive: false,
                isMarginTop: true,
                isRefreshShow: false
            }
        },
        {
            path: '/getVirtualPrize/:winId/:itemExchSta/:itemExchNum/:itemName',
            name: 'getVirtualPrize',
            component: getVirtualPrize,
            meta: {
                title: '奖品领取',
                backIsshow: true,
                shareIsshow: false,
                keepAlive: false,
                isMarginTop: true,
                isRefreshShow: true
            }
        }, {
            path: '/addressSelect/:winId/:itemExchSta/:itemExchNum',
            name: 'addressSelect',
            component: addressSelect,
            meta: {
                title: '地址选择',
                backIsshow: true,
                shareIsshow: false,
                keepAlive: false,
                isMarginTop: true,
                isRefreshShow: false
            }
        },
        {
            path: '/luckyMoneyDetail',
            name: 'luckyMoneyDetail',
            component: luckyMoneyDetail,
            meta: {
                title: '幸运币明细',
                backIsshow: true,
                shareIsshow: false,
                keepAlive: false,
                isMarginTop: true,
                isRefreshShow: true
            }
        },
        {
            path: '/luckyNumDetail',
            name: 'luckyNumDetail',
            component: luckyNumDetail,
            meta: {
                title: '账户明细',
                backIsshow: true,
                shareIsshow: false,
                keepAlive: false,
                isMarginTop: true,
                isRefreshShow: true
            }
        },
        {
            path: '/loginOrReg/:type?',
            name: 'loginOrReg',
            component: loginOrReg,
            meta: {
                title: '',
                backIsshow: false,
                shareIsshow: false,
                keepAlive: true,
                isMarginTop: false,
                isRefreshShow: false
            }
        },
        {
            path: '/modifyUserName',
            name: 'modifyUserName',
            component: modifyUserName,
            meta: {
                title: '修改用户名',
                backIsshow: true,
                shareIsshow: false,
                keepAlive: false,
                isMarginTop: true,
                isRefreshShow: true
            }
        },
        {
            path: '/bindPhone',
            name: 'bindPhone',
            component: bindPhone,
            meta: {
                title: '绑定手机',
                backIsshow: true,
                shareIsshow: false,
                keepAlive: false,
                isMarginTop: true,
                isRefreshShow: true
            }
        },
        {
            path: '/pModify',
            name: 'pModify',
            component: pModify,
            meta: {
                title: '修改登录密码',
                backIsshow: true,
                shareIsshow: false,
                keepAlive: false,
                isMarginTop: true,
                isRefreshShow: true
            }
        },
        {
            path: '/pGetBack',
            name: 'pGetBack',
            component: pGetBack,
            meta: {
                title: '找回密码',
                backIsshow: true,
                shareIsshow: false,
                keepAlive: false,
                isMarginTop: true,
                isRefreshShow: false
            }
        },
        {
            path: '/pay/:from/:orderId?',
            name: 'pay',
            component: pay,
            meta: {
                title: '获取幸运币',
                backIsshow: false,
                shareIsshow: false,
                keepAlive: false,
                isMarginTop: false,
                isRefreshShow: true
            }
        },
        {
            path: '/luckyPay/:from?/:orderId?',
            name: 'luckyPay',
            component: luckyPay,
            meta: {
                title: '充值',
                backIsshow: true,
                shareIsshow: false,
                keepAlive: false,
                isMarginTop: true,
                isRefreshShow: true
            }
        },
        {
            path: '/payHelp',
            name: 'payHelp',
            component: payHelp,
            meta: {
                title: '支付帮助',
                backIsshow: true,
                shareIsshow: false,
                keepAlive: false,
                isMarginTop: true,
                isRefreshShow: true
            }
        },
        {
            path: '/latesNews',
            name: 'LatesNews',
            component: latesNews,
            meta: {
                title: '最新揭晓',
                backIsshow: true,
                shareIsshow: false,
                keepAlive: false,
                isMarginTop: true,
                isRefreshShow: true
            }
        },
        {
            path: '/giftMoreDetail/:issueId/:issueName/:itemBought',
            name: 'giftMoreDetail',
            component: giftMoreDetail,
            meta: {
                title: '参与详情',
                backIsshow: true,
                shareIsshow: false,
                keepAlive: false,
                isMarginTop: true,
                isRefreshShow: false
            }
        },
        {
            path: '/regProtocol',
            name: 'regProtocol',
            component: regProtocol,
            meta: {
                title: '注册协议',
                backIsshow: true,
                shareIsshow: false,
                keepAlive: false,
                isMarginTop: true,
                isRefreshShow: false
            }
        },
        {
            path: '/caculateDetail/:allPeople/:issueId',
            name: 'caculateDetail',
            component: caculateDetail,
            meta: {
                title: '计算详情',
                backIsshow: true,
                shareIsshow: false,
                keepAlive: false,
                isMarginTop: true,
                isRefreshShow: true
            }
        },
        {
            path: '/analysis',
            name: 'analysis',
            component: analysis,
            meta: {
                title: '幸运号码',
                backIsshow: true,
                shareIsshow: false,
                keepAlive: false,
                isMarginTop: true,
                isRefreshShow: false
            }
        },
        {
            path: '/historyAnalysis/:lotteryName',
            name: 'historyAnalysis',
            component: historyAnalysis,
            meta: {
                title: '历史战绩',
                backIsshow: false,
                shareIsshow: false,
                keepAlive: false,
                isMarginTop: false,
                isRefreshShow: false
            }
        },
		{
            path: '/historyAnalysis1/:lotteryName',
            name: 'historyAnalysis1',
            component: historyAnalysis1,
            meta: {
                title: '快乐8历史战绩',
				        backIsshow: false,
                shareIsshow: false,
                keepAlive: false,
                isMarginTop: false,
                isRefreshShow: false
            }
        },
        {
            path: '/historyAnalysisDetail/:lotteryName',
            name: 'historyAnalysisDetail',
            component: historyAnalysisDetail,
            meta: {
                title: '历史战绩',
                backIsshow: false,
                shareIsshow: false,
                keepAlive: false,
                isMarginTop: false,
                isRefreshShow: false
            }
        },
         {
            path: '/excellentPlan/:lotteryName',
            name: 'excellentPlan',
            component: excellentPlan,
            meta: {
                title: '优秀方案',
                backIsshow: false,
                shareIsshow: false,
                keepAlive: false,
                isMarginTop: false,
                isRefreshShow: false
            }
        }

    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js